import React from 'react';
import { cn, getStatusConfig } from '../../lib/utils';

export const StatusBadge = ({ status, size = 'default' }) => {
  const config = getStatusConfig(status);
  
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 font-medium border rounded-full",
        config.color,
        size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm'
      )}
      data-testid={`status-badge-${status.toLowerCase()}`}
    >
      <span className={cn("w-1.5 h-1.5 rounded-full", config.dotColor)} />
      {config.label}
    </span>
  );
};

export default StatusBadge;
